// events name - for display on system
// Map for all the possible events name

import { Title } from 'chart.js';
import { text } from 'express';

export const eventNameDetailMapper = {
  LW_RESPONSE_SIBLINGS_UPDATED: { displayText: 'Related Feeds Updated' },
  LW_USERS_SKIPPED: { displayText: 'Users Skipped' },
  LW_REQUEST_TRIGGERED: { displayText: 'Request Triggered' },
  LW_RESPONSE_TEXT_ANALYTICS_UPDATED: { displayText: 'Text Category Updated' },
  LW_RESPONSE_CUSTOM_PARAMETERS_UPDATED: {
    displayText: 'Custom Parameter Updated',
  },
  LW_RESPONSE_STATUS_CHANGED: { displayText: 'Status Changed' },
  status_changed: { displayText: 'Status Changed' },
  LW_RESPONSE_CATEGORY_CHANGED: { displayText: 'Category Changed' },
  category_changed: { displayText: 'Category Changed' },
  LW_RESPONSE_TAG_ADDED: { displayText: 'Tag(s) Added' },
  LW_RESPONSE_TAG_REMOVED: { displayText: 'Tag(s) Removed' },
  LW_RESPONSE_ASSIGNEE_REMOVED: { displayText: 'Assignee Removed' },
  LW_RESPONSE_ASSIGNEE_ADDED: { displayText: 'Assignee Added' },
  LW_RESPONSE_ASSIGNEE_CHANGED: { displayText: 'Assignee Changed' },
  LW_RESPONSE_FOLLOWERS_ADDED: { displayText: 'Followers Added' },
  LW_RESPONSE_FOLLOWERS_REMOVED: { displayText: 'Followers Removed' },
  LW_NOTE_ADDED: { displayText: 'Notes Added' },
  LW_COMMENT_ADDED: { displayText: 'Comment Added' },
  LW_CUSTOMER_COMMENT: { displayText: 'Customer Comment' },
  LW_MANAGER_COMMENT: { displayText: 'Manager Comment' },
  LW_EMAIL_NOTIFICATION: { displayText: 'Email Notification' },
  LW_SMS_NOTIFICATION: { displayText: 'SMS Notification' },
  LW_AUTO_RESPONSE: { displayText: 'Auto Reply' },
  LW_API_REQUEST: { displayText: 'API Request' },
  LW_PUSH_NOTIFICATIONS: { displayText: 'Push Notification' },
  LW_AUTO_ASSIGNMENT: { displayText: 'Auto Assignment' },
  LW_AUTO_ASSIGNMENT_FOLLOWERS: { displayText: 'Auto Assignment' },
  LW_TS_HOOK_EXECUTED: { displayText: 'SMS/Email Notification' },
};

// for message(action performed) based on event
export const metaDataFieldsMapper = {
  LW_RESPONSE_CUSTOM_PARAMETERS_UPDATED: 'field_definitions',
  LW_RESPONSE_STATUS_CHANGED: {
    field_id: 'status_list',
    message: 'Status changed from {{oldValue}} to  {{value}}',
  },
  status_changed: {
    field_id: 'status_list',
    message: 'Status changed from {{oldValue}} to  {{value}}',
  },
  LW_RESPONSE_CATEGORY_CHANGED: {
    field_id: 'category_list',
    message: 'Categroy was changed from {{oldValue}} to {{value}}',
  },
  category_changed: {
    field_id: 'category_list',
    message: 'Categroy was changed from {{oldValue}} to {{value}}',
  },
  LW_RESPONSE_TAG_ADDED: {
    field_id: 'tag_list',
    message: 'Tag(s) - {{value}} has been added.',
  },
  LW_RESPONSE_TAG_REMOVED: {
    field_id: 'tag_list',
    message: 'Tag(s) - {{value}} has been removed.',
  },
  LW_RESPONSE_ASSIGNEE_REMOVED: {
    field: 'assigned_to_id_list',
    message: '{{value}} has been removed from Assignee.',
  },
};

// for message(action performed) based on event
// Map for all the possible external events (Not available at brand meta data)
export const externalFieldsMapper = {
  LW_RESPONSE_ASSIGNEE_REMOVED: '{{value}} has been removed from Assignee.',
  LW_RESPONSE_ASSIGNEE_ADDED: '{{value}} has been added as Assignee.',
  LW_RESPONSE_ASSIGNEE_CHANGED: 'Assignee changed.',
  LW_RESPONSE_FOLLOWERS_ADDED: '{{value}} has been added as Followers.',
  LW_RESPONSE_FOLLOWERS_REMOVED: '{{value}} has been removed from Followers.',
  LW_NOTE_ADDED: 'A Notes has been added',
  LW_COMMENT_ADDED: 'A reply has been received',
  LW_CUSTOMER_COMMENT: 'Reply received by the customer',
  LW_MANAGER_COMMENT: 'Replied to the customer',
};

// history table columns
// export const columns_names = [
//     {
//         "dataKey": "event_name",
//         "header": "Event Name",
//         "enabled":true
//         // "size": 2,
//     }, {
//         "dataKey": "created_date",
//         "header": "Date and Time", "enabled":true
//         // "size": 3,
//     }, {
//         "dataKey": "performed_by",
//         "header": "Performed By",
//         "enabled":true
//         // "size": 3,
//     },
//     {
//         "dataKey": "event",
//         "header": "Action Performed",
//         "enabled":true
//         // "size": 4,
//     }
// ]
export const columns_names = [
  {
    header: 'Event Name',
    dataKey: 'event_name',
    enabled: true,
    sortingEnabled: true,
    dataType: 'string',
    clickable: true,
    order: 1,
    style: {
      headerTextAlign: 'left',
      cellTextAlign: 'left',
    },
  },
  {
    header: 'Date and Time',
    dataKey: 'created_date',
    dataType: 'number',
    order: 2,
    // "width": "20%",
    // "is_deviation_enabled": false,
    enabled: true,
    sortingEnabled: true,
    style: {
      headerTextAlign: 'left',
      cellTextAlign: 'left',
    },
  },
  {
    header: 'Performed By',
    dataKey: 'performed_by',
    dataType: 'number',
    order: 3,
    // "width": "20%",
    // "is_deviation_enabled": false,
    enabled: true,
    sortingEnabled: true,
    style: {
      headerTextAlign: 'left',
      cellTextAlign: 'left',
    },
  },
  {
    header: 'Action Performed',
    dataKey: 'event',
    dataType: 'number',
    order: 4,
    // "width": "20%",
    // "is_deviation_enabled": false,
    enabled: true,
    sortingEnabled: true,
    style: {
      headerTextAlign: 'left',
      cellTextAlign: 'left',
    },
  },
];

export const activeTasks: any = [
  {
    heading: 'Action plans',
    data: [],
  },
];

export const huddleHighlights = [
  {
    heading: 'Spotlights',
    unit: '0',
  },
  {
    heading: 'Action plan',
    unit: '0',
  },
  {
    heading: 'Suggesstion',
    unit: '0',
  },
];

export const editActionPlann = [
  {
    Title: 'Owner',
    text: 'dolorsitamet@loremipsumdolorsit.com',
  },
  {
    Title: 'Status',
    text: 'Closed',
  },
  {
    Title: 'Theme',
    text: 'Employee interaction experience',
  },
  {
    Title: 'Reasons',
    text: 'Select an option',
  },
];

export const actionDots = [
  {
    title: 'Closed',
    color: '#76C68F',
  },
  {
    title: 'Open',
    color: '#76C68FB3',
  },
  {
    title: 'N/A',
    color: '#76C68F80',
  },
];
export const suggDots = [
  {
    title: 'Assigned to Cluster Head',
    color: '#FFD23F',
  },
];

export const assignColors = {
  'Assign to Cluster Head': 'rgb(187, 213, 49)',
  'Assigned to Circle Head': 'rgb(245, 234, 20)',
  'Assigned to Cluster Head': 'rgb(102, 184, 70)',
  'Assigned to Zonal Head': 'rgb(44, 123, 182)',
  'Assign to Circle Head': 'rgb(44, 123, 182)',
  'Closed': 'rgb(11, 113, 57)',
  'Open': 'rgb(237, 36, 36)',
  'N/A': 'rgb(136, 136, 136)',
  '': 'rgb(44, 123, 182)',
};
